<!-- eslint-disable max-len -->
<style scoped>
  .checkbox-hidden {
    display: none;
  }
  .ckbox-z {
    input { z-index: 1 !important; }
  }
  /* Ensure target checkboxes remain clickable in modal */
  #projectTOGModal .tog-tab-card-list > .custom-control > .custom-control-label > div {
    pointer-events: none !important;
  }

  #projectTOGModal .tog-tab-card-list > .custom-control > .custom-control-label > div * {
    pointer-events: auto !important;
  }

  #projectTOGModal .custom-control-input {
    pointer-events: auto !important;
  }
  #projectTOGModal .custom-control-label::before,
  #projectTOGModal .custom-control-label::after {
    pointer-events: auto !important;
  }

  .project-goals-instruction {
      color: #863A21;
      font-size: 0.85em;
      font-style: italic;
      font-weight: normal;
  }
  .project-goals-label {
    font-weight:normal;
    color: #1D252C;
  }
  .unavailable-label {
    font-weight:normal;
    color:rgb(164, 164, 164) !important;
  }
  .report-target-plus {
    font-size: 15px;
    font-weight:normal;
    cursor: pointer;
    color: #444444;
    margin-right:4px;
  }
  .minus {
    font-size: 22px;
    margin-right: 6px;
  }
  .report-target-div {
    font-size: 1rem;
    font-weight:normal;
    cursor: pointer;
    color: #444444;
  }
  .report-target-div-content {
    margin-left:10px;
  }
  .report-items {
    font-size: 1rem;
    font-weight:normal;
    color: #444444;
  }
  .report-goal-list {
    width: 95% !important;
  }
  .report-goal-radio {
    width: 5% !important;
  }
  .selected-item {
    font-weight: bold;
  }
  .report-tog-card {
    width: 100%;
    border-top:0px;
    display: flex;
  }
  .report-tog-card-wrapper {
  /* border: 1px solid rgba(0, 0, 0, 0.125); */
  }
  .export-btn {
    display: flex;
    margin: 10px;
    justify-content: flex-end;
  }
  .no-border-bottom {
    border-bottom: 0 !important;
  }
  .no-border-top {
    border-top: 0 !important;
  }
  .save-desc {
    font-size: 13px;
    font-weight: normal;
    font-style: italic;
  }
  .item-center {
    align-items: center;
  }
  .required-red {
    color:red;
  }
  .form-group label {
      font-weight: bold;
      color: #1D252C !important;
  }
  .report-header-row {
    font-weight: bold;
    /* background-color: #f8f9fa; */
    border-top: 2px solid #dee2e6;
    border-bottom: 2px solid #dee2e6;
    padding: 10px 0;
  }
  .goal-radio-wrapper {
    display: flex;
    align-items: center;
    min-height: 24px;
    padding: 0.25rem 0;
  }
  .goal-checkbox-wrapper {
    display: flex;
    align-items: center;
    min-height: 24px;
  }
  .goal-row-wrapper {
    display: flex;
    align-items: flex-start;
    min-height: 24px;
    margin-bottom: 0.25rem;
  }
  .report-bullet {
    color: #1D252C;
    font-size: 1rem;
    line-height: 1.5;
    margin-right: 6px;
    flex: 0 0 auto;
    align-self: flex-start;
  }
  .report-column-content {
    width: 95%;
  }
  .report-column-content {
    label {width: 95%;}
  }
  .report-column-content .bv-no-focus-ring .custom-checkbox {
    label {width: 95%;}
  }

  .report-column-content {
    div {width: 100%;}
  }

  /* Hide checkboxes in report section but keep text labels */
  #report ::v-deep .custom-checkbox input[type="checkbox"] {
    display: none !important;
  }

  #report ::v-deep .custom-checkbox .custom-control-label::before,
  #report ::v-deep .custom-checkbox .custom-control-label::after {
    display: none !important;
  }

  #report ::v-deep .custom-checkbox .custom-control-label {
    padding-left: 0 !important;
  }

  /* Make disabled target text color black in report section */
  #report ::v-deep .custom-checkbox input[type="checkbox"]:disabled + .custom-control-label {
    color: #1D252C !important;
  }
</style>
<template>
  <div class="view-contents">
    <UnavailablePageModal
      v-if="project"
      pageName="Goals"
      :project="project"
      :projectId="project.id"
    />
    <b-alert
      :show="dismissProjectGoalValidationErrorAlert"
      dismissible
      variant="danger"
      @dismissed="dismissProjectGoalValidationErrorAlert=0"
      @dismiss-count-down="dismissProjectGoalValidationErrorAlertChanged"
    >
      <span>Select at least 1 Project Goal.</span>
    </b-alert>
    <b-alert
      :show="dismissProjectObjectiveValidationErrorAlert"
      dismissible
      variant="danger"
      @dismissed="dismissProjectObjectiveValidationErrorAlert=0"
      @dismiss-count-down="dismissProjectObjectiveValidationErrorAlertChanged"
    >
      <span>Select at least 1 Project Objective for each selected Target.</span>
    </b-alert>
    <b-alert
      :show="dismissProjectGoalSaveSuccessAlert"
      dismissible
      variant="success"
      @dismissed="dismissProjectGoalSaveSuccessAlert=0"
      @dismiss-count-down="dismissProjectGoalSaveSuccessAlertChanged"
    >
      <span>Project Targets were successfully saved.</span>
    </b-alert>
    <div class="section-header">
      <b-overlay :show="projectGoalsSaving || togExportLoading">
        <div class="row bold-title section-header item-center">
          <div class="col">
            <span>Targets</span>
            <span class="save-desc">
              <b-button v-if='isEditable'
              id='reportSave'
              :title="!isReportSavable ? 'Not all required selected.' : ''"
              :disabled="!isReportSavable" pill variant="primary" size="sm" class="tog-submit-form-button" @click="onSaveClick">
              <span>Save</span>
            </b-button>
            </span>
          </div>

        </div>
        <div class='row'>
          <div class='col'>
            <b-link v-if='isEditable' class="add-link" @click="onOpenProjectTOGModalClick">
              <b-icon :icon="hasPrimaryGoalSelection ? 'pencil' : 'plus'"></b-icon>{{hasPrimaryGoalSelection ? ' Edit Target' : ' Add Target'}}
            </b-link>
            <b-modal id="projectTOGModal" :title="hasPrimaryGoalSelection ? 'Edit Target' : 'Add Target'" size="xl" hide-footer hide-header-close no-close-on-backdrop @shown="onProjectTOGModalShown">
              <div class="">
              <div class="" style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap;">
                <div style="max-width: 645px; flex: 1;">
                  <b-form-select
                    v-model="goalDropdownValue"
                    :options="goalFilterOptions"
                    size="sm"
                    @change="onGoalFilterSelect">
                    <template #first>
                      <b-form-select-option :value="null">
                        -- Filter Targets by Strategic Goals --
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </div>
                <div>
                  <b-button
                    id='modalCancel'
                    pill variant="secondary" size="sm" class="tog-submit-form-button" @click="onCancelClick" style="margin-left: 10px;">
                    <span>Cancel</span>
                  </b-button>
                  <b-button v-if='isEditable'
                    id='modalSave'
                    :title="!isSavable ? 'Not all required selected.' : ''"
                    :disabled="!isSavable" pill variant="primary" size="sm" class="tog-submit-form-button" @click="onSaveClick" style="margin-left: 10px;">
                    <span>Save</span>
                  </b-button>
                </div>
              </div>
                <div style="padding: 0 15px; margin-bottom: 8px;">
                  <div v-if="selectedGoalFilterNames.length > 0" style="margin-top: 6px;">
                    <span
                      v-for="goal in selectedGoalFilterNames"
                      :key="goal.id"
                      style="display: inline-block; background: #e9ecef; border-radius: 4px; padding: 2px 8px; margin-right: 6px; margin-bottom: 4px; font-size: 0.85rem;">
                      {{ goal.name }}
                      <span
                        @click="removeGoalFilter(goal.id)"
                        style="cursor: pointer; margin-left: 4px; font-weight: bold; color: #dc3545;">&times;</span>
                    </span>
                  </div>
                </div>
                <div class="tog-card no-border-bottom" style="align-items: stretch;">
                  <div class="col site-section-wrapper tog-card-1st">
                    <div class="col bold-title">
                      <span>Targets</span><span class="required-red">*</span>
                    </div>
                    <div class="card card-body tog-list">
                      <b-form-group>
                        <b-form-checkbox-group v-model='tempProjectAccomplishmentTargetIdsSelected' name='adjustedProjectTargets' class='tog-tab-card-list'>
                          <b-form-checkbox
                          v-for="item in filteredModalTargets"
                          :disabled="isTargetUnavailable(item)"
                          :id="'T-' + item.id"
                          :key="item.id"
                          :value="item.id"
                          :class="['ckbox-z']"
                          @change="handleTargetCheckboxChange()">
                            <span
                            @click.prevent="toggleTargetSelection(item.id, isTargetUnavailable(item))"
                            :title="targetUnavailableTitle(item)"
                            :class="['project-goals-label', , isTargetUnavailable(item) ? 'unavailable-label' : '']">{{ item.name }}</span>
                            <!-- Objectives intentionally hidden from the Edit/Add Target modal even when the target is checked. -->
                            <div v-if="false" :class='`${item.childClass}`'>
                              <b-form-checkbox-group v-model='item.tempProjectAccomplishmentTargetObjectiveSelected' name='projectObjectives' class='tog-tab-card-list'>
                                <b-form-checkbox
                                v-for="(projectAccomplishmentTargetObjective) in item.projectAccomplishmentTargetObjectives"
                                :key="`${projectAccomplishmentTargetObjective.id}|${item.id}`"
                                :id="`${projectAccomplishmentTargetObjective.id}|${item.id}`"
                                :value="`${projectAccomplishmentTargetObjective.id}|${item.id}`"
                                :disabled=true
                                @change="updateSelectedTargetObjectives($event, [`${projectAccomplishmentTargetObjective.id}|${item.id}`])"
                                :class="[item.tempProjectAccomplishmentTargetObjectiveSelected && item.tempProjectAccomplishmentTargetObjectiveSelected.includes(`${projectAccomplishmentTargetObjective.id}|${item.id}`) === true ? '' : 'checkbox-hidden']">

                                  <div
                                  :title="projectAccomplishmentTargetObjective.projectObjectiveGoals.length === 0 ? 'No associated Goals available.' : ''"
                                  :class="['project-goals-label', projectAccomplishmentTargetObjective.projectObjectiveGoals.length === 0 ? 'unavailable-label' : '']">{{ projectAccomplishmentTargetObjective.name }}</div>
                                  <!--<div :class='`${projectAccomplishmentTargetObjective.childClass}`'>
                                    <b-form-checkbox-group v-model='projectGoalsSelected' name='projectGoals' class='tog-tab-card-list'>
                                      <b-form-checkbox v-for="(projectObjectiveGoal) in projectAccomplishmentTargetObjective.projectObjectiveGoals" :id="'G-' + projectObjectiveGoal.id" :key="projectObjectiveGoal.id" :value="projectObjectiveGoal.id" :class='`${item.class}`'>
                                        <div class='project-goals-label'>{{ projectObjectiveGoal.name }}
                                          <b-form-checkbox >
                                            <div class='project-goals-label'></div>
                                          </b-form-checkbox>
                                        </div>
                                      </b-form-checkbox>
                                    </b-form-checkbox-group>
                                  </div>-->
                                </b-form-checkbox>
                              </b-form-checkbox-group>
                            </div>
                          </b-form-checkbox>
                        </b-form-checkbox-group>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="col site-section-wrapper tog-card-3rd">
                    <div class="col bold-title set-between">
                      <div><span>Goals</span><span class="required-red">*</span></div>
                      <div><span>Primary</span><span class="required-red">*</span></div>
                    </div>
                    <div class="card card-body tog-list">
                      <b-form-group>
                        <div class='tog-tab-card-list'>
                          <div
                            v-for="item in modalAvailableProjectGoals"
                            :id="'G-' + item.id"
                            :key="item.id"
                            :class='`${item.class}`'>
                            <div class='project-goals-label set-between' style="display: flex; align-items: center; width: 100%;">
                              <div style="display: flex; align-items: flex-start; flex: 1;">
                                <span class="report-bullet">&bull;</span>
                                <span>{{ item.name }}</span>
                              </div>
                              <b-form-radio-group v-model='tempProjectPrimaryGoalsSelected' name='modalPrimaryRadio' class='tog-tab-card-list goal-primary'>
                                <div class='goal-primary'>
                                  <b-form-radio
                                  :disabled="!tempProjectGoalsSelected.includes(item.id)"
                                  :id="'PG-' + item.id"
                                  :name="'PG-' + item.id"
                                  :key="item.id"
                                  :value="item.id"></b-form-radio>
                                </div>
                              </b-form-radio-group>
                            </div>
                          </div>
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                </div>
              </div>
            </b-modal>
          </div>
        </div>
        <div class="col">
          <div class="goal-card-header goal-card-header-side checkbox-hidden">
            <div class="row">
              <div class="col-4">
                <a v-b-toggle.tog class="c-pointer">
                  <b-icon icon='caret-right-fill' class="when-closed" />
                  <b-icon icon='caret-down-fill' class="when-opened" />
                  Target, Objective, and Goal
                </a>
              </div>
            </div>
          </div>
          <b-collapse id="report" class="" visible>
            <div class="report-tog-card-wrapper no-border-top">
                <div v-if='selectedProjectTargets.length < 1 || projectGoalsSelected.length < 1'>No Targets have been added.</div>
              <div class="">
                <b-form-group v-if='selectedProjectTargets.length > 0 && projectGoalsSelected.length > 0'>
                  <b-form-checkbox-group v-model='projectAccomplishmentTargetIdsSelected' name='adjustedProjectTargets'>
                    <!-- Header Row -->
                    <div class="row report-header-row">
                      <div style="width: 37%;padding-left: 1.5rem;"><div class="report-column-content">Target</div></div>
                      <div style="width: 28%;padding-left: 1.5rem;"><div class="report-column-content">Objectives</div></div>
                      <div style="width: 28%;padding-left: 1.5rem;"><div class="report-column-content" style="display: flex; justify-content: space-between;"><span>Goals</span><span>Primary</span></div></div>
                      <div style="width: 7%;padding-left: 1.5rem;"><div class="report-column-content"></div></div>
                    </div>

                    <!-- Data Rows -->
                    <div
                      class="row align-items-start border-bottom py-2">

                      <!-- Column 1A: Unique Targets -->
                      <div style="width: 37%;">
                        <div class="report-column-content">
                          <div
                            v-for="item in selectedProjectTargets"
                            :id="'T-' + item.id"
                            :key="item.id"
                            class="goal-row-wrapper">
                            <span class="report-bullet">&bull;</span>
                            <b-form-checkbox
                              :value="item.id"
                              :disabled="true"
                              style="flex: 1;"
                              :title="item.projectAccomplishmentTargetObjectives.length === 0 ? 'No associated Objectives available.' : ''">
                              {{ item.name }}
                            </b-form-checkbox>
                          </div>
                        </div>
                      </div>

                      <!-- Column 1B: Unique Objectives -->
                      <div style="width: 28%;">
                        <div class="report-column-content">
                          <div
                            v-for="objective in uniqueSelectedObjectives"
                            :key="objective.id"
                            class="goal-row-wrapper">
                            <span class="report-bullet">&bull;</span>
                            <b-form-checkbox
                              :value="objective.id"
                              :disabled="true">
                              {{ objective.name }}
                            </b-form-checkbox>
                          </div>
                        </div>
                      </div>

                      <!-- Column 1C: Unique Goals and Primary -->
                      <div style="width: 28%;">
                        <div class="report-column-content">
                          <div
                            v-for="goal in uniqueSelectedGoals"
                            :key="goal.id"
                            class="goal-row-wrapper">
                            <div style="display: flex; justify-content: space-between; align-items: flex-start; width: 100%;">
                              <span class="report-bullet">&bull;</span>
                              <b-form-checkbox
                                :id="'G-' + goal.id"
                                :value="goal.id"
                                :disabled="true"
                                style="flex: 1;">
                                {{ goal.name }}
                              </b-form-checkbox>
                              <div style="width: 30px; display: flex; justify-content: center; align-items: center;">
                                <b-form-radio
                                  v-model='projectPrimaryGoalsSelected'
                                  :id="'PGR-' + goal.id"
                                  name="primaryRadio"
                                  :value="goal.id"
                                  :checked="projectPrimaryGoalsSelected === goal.id"
                                  :disabled="!isEditable">
                                </b-form-radio>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Column 1D: Spacer (Delete moved into Target column) -->
                      <div style="width: 7%;">
                        <div class="report-column-content"></div>
                      </div>
                    </div>
                  </b-form-checkbox-group>
                </b-form-group>
              </div>
              <div class="export-btn" v-if='selectedProjectTargets.length > 0 && projectGoalsSelected.length > 0'>
                <b-button
                :title="!isExportable ? 'Please save any changes made first.' : ''"
                :disabled="!isExportable" pill variant="primary" size="sm" class="submit-form-button" @click="onExportClick">
                  <span>Export</span>
                </b-button>
              </div>
            </div>
          </b-collapse>
        </div>
        <div class="row">
        </div>
      </b-overlay>
    </div>
  </div>
</template>
<script>
/* eslint-disable max-len, no-param-reassign, padded-blocks, prefer-destructuring */
import { mapState } from 'vuex';
import UnavailablePageModal from '@/components/common/UnavailablePageModal.vue';
import ProjectApprovalMembershipManager from '@/mixins/projectApprovalMembershipManager';
import exitFormModal from '@/mixins/exitFormModal';
import TargetObjectiveGoalManager from '@/mixins/targetObjectiveGoalManager';

export default {
  name: 'ProjectContacts',
  mixins: [TargetObjectiveGoalManager, ProjectApprovalMembershipManager, exitFormModal],
  components: {
    UnavailablePageModal,
  },
  computed: {
    ...mapState(['currentSite', 'config']),
    ...mapState('Project', {
      project: (state) => state.project,
      projectAccomplishmentTargets: (state) => state.projectAccomplishmentTargets,
      projectGoals: (state) => state.projectGoals,
      projectGoalSelections: (state) => state.projectGoalSelections,
      projectObjectives: (state) => {
        const objectives = [...state.projectObjectives].sort((a, b) => a.name.localeCompare(b.name));
        objectives.forEach((item) => {
          item.projectObjectiveAccomplishmentTargets.sort(
            (a, b) => a.projectAccomplishmentTarget.name.localeCompare(b.projectAccomplishmentTarget.name),
          );
        });

        return objectives;
      },
      projectObjectiveSelections: (state) => state.projectObjectiveSelections,
      projectObjectiveAccomplishmentTargetSelections: (state) => state.projectObjectiveAccomplishmentTargetSelections,
    }),
    hasPrimaryGoalSelection() {
      return this.projectPrimaryGoalsSelected != null;
    },
    isSavable() {
      // Use temp variables for modal validation
      const hasObjectiveSelections = this.getTempSelectedObjectiveIds().length > 0;
      const hasGoalSelections = this.tempProjectGoalsSelected.length > 0;
      const hasTempPrimaryGoal = this.tempProjectPrimaryGoalsSelected != null;
      this.checkExportable();
      // return ((!hasObjectiveSelections && !hasGoalSelections && !hasTempPrimaryGoal) || (hasObjectiveSelections && hasGoalSelections && hasTempPrimaryGoal));
      return (hasObjectiveSelections && hasGoalSelections && hasTempPrimaryGoal);
    },
    isReportSavable() {
      // Use actual variables for report Save button validation
      const hasTargets = this.selectedProjectTargets.length > 0;
      const hasGoals = this.projectGoalsSelected.length > 0;
      const hasPrimaryGoal = this.projectPrimaryGoalsSelected != null;
      return (hasTargets && hasGoals && hasPrimaryGoal);
    },
    uniqueSelectedObjectives() {
      // Flat, de-duplicated list of objective objects across all selected targets
      const objectiveIds = new Set();
      const objectives = [];
      this.selectedProjectTargets.forEach((target) => {
        (target.projectAccomplishmentTargetObjectives || []).forEach((objective) => {
          const key = `${objective.id}|${target.id}`;
          const isSelected = (target.projectAccomplishmentTargetObjectiveSelected || []).includes(key)
            || this.projectObjectivesSelected.includes(objective.id);
          if (isSelected && !objectiveIds.has(objective.id)) {
            objectiveIds.add(objective.id);
            objectives.push(objective);
          }
        });
      });
      objectives.sort((a, b) => a.name.localeCompare(b.name));
      return objectives;
    },
    uniqueSelectedGoals() {
      // Flat, de-duplicated list of goal objects that are currently selected
      const goalIds = new Set();
      const goals = [];
      this.availableProjectGoals.forEach((goal) => {
        if (this.projectGoalsSelected.includes(goal.id) && !goalIds.has(goal.id)) {
          goalIds.add(goal.id);
          goals.push(goal);
        }
      });
      goals.sort((a, b) => a.name.localeCompare(b.name));
      return goals;
    },
    goalFilterOptions() {
      return [...this.adjustedProjectGoals]
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((goal) => ({ value: goal.id, text: goal.name }));
    },
    selectedGoalFilterNames() {
      return this.selectedGoalFilters.map((id) => {
        const goal = this.adjustedProjectGoals.find((g) => g.id === id);
        return goal ? { id, name: goal.name } : { id, name: `Goal ${id}` };
      });
    },
    filteredModalTargets() {
      // A target matches when any of its objectives rolls up to any goal being
      // filtered on. Visibility only - targets already checked stay checked.
      if (this.selectedGoalFilters.length === 0) {
        return this.adjustedProjectTargets;
      }
      return this.adjustedProjectTargets.filter((target) => (target.projectAccomplishmentTargetObjectives || []).some(
        (objective) => (objective.projectObjectiveGoals || []).some((goal) => this.selectedGoalFilters.includes(goal.id)),
      ));
    },
  },
  data() {
    return {
      dismissProjectGoalValidationErrorAlert: 0,
      dismissProjectObjectiveValidationErrorAlert: 0,
      dismissProjectGoalSaveSuccessAlert: 0,
      projectId: null,
      projectGoalsSaving: false,
      adjustedProjectTargets: [],
      adjustedProjectObjectives: [],
      adjustedProjectGoals: [],
      projectAccomplishmentTargetIdsSelected: [],
      projectObjectivesSelected: [],
      projectGoalsSelected: [],
      projectPrimaryGoalsSelected: null,
      availableProjectGoals: [],
      selectedProjectTargets: [],
      isExportable: true,
      togExportLoading: false,
      savedTargetSelections: [],
      savedObjectivesSelections: [],
      savedGoalSelections: [],
      savedPrimaryGoalId: null,
      projectTOGModalId: 'projectTOGModal',
      // Temporary variables for modal staging
      tempProjectAccomplishmentTargetIdsSelected: [],
      tempProjectGoalsSelected: [],
      tempProjectPrimaryGoalsSelected: null,
      // Separate goals list used only inside the modal (does not affect the report)
      modalAvailableProjectGoals: [],
      // Saved primary captured at modal open so we can re-apply it after the modal's
      // radios finish mounting (BootstrapVue per-row b-form-radio-group instances
      // sometimes don't reflect a v-model value set before they mount).
      pendingPrimaryToRestore: null,
      selectedGoalFilters: [],
      goalDropdownValue: null,
    };
  },
  watch: {
    projectAccomplishmentTargetIdsSelected(newValues) {
      const objectivesTobeUnselected = [];

      const objectiveCheckboxes = document.getElementsByName('projectObjectives');
      this.adjustedProjectTargets.forEach((projectTarget) => {
        // == show objectives of selected target
        if (newValues.includes(projectTarget.id)) {
          projectTarget.childClass = '';
          const allProjectObjectivesElements = document.getElementsByName('projectObjectives');

          allProjectObjectivesElements.forEach((projectObjectivesElement) => {
            const targetId = parseInt(projectObjectivesElement.id.split('|')[1], 10);
            if (projectTarget.id === targetId && !projectTarget.projectAccomplishmentTargetObjectiveSelected.includes(projectObjectivesElement.id)) {
              projectTarget.projectAccomplishmentTargetObjectiveSelected.push(projectObjectivesElement.id);
            }
          });
        } else {
          // == hide objectives and unselect all
          projectTarget.childClass = 'checkbox-hidden';

          projectTarget.projectAccomplishmentTargetObjectiveSelected.forEach((selection) => {
            const objId = parseInt(selection.split('|')[0], 10);
            if (this.projectObjectivesSelected.includes(objId)) {
              const index = this.projectObjectivesSelected.indexOf(objId);
              this.projectObjectivesSelected.splice(index, 1);
            }
            // uncheck all hidden objective checkboxes for isExportable check
            objectiveCheckboxes.forEach((obj) => {
              if (obj.defaultValue === selection) {
                obj.checked = false;
              }
            });
          });
          projectTarget.projectAccomplishmentTargetObjectiveSelected = [];

          // this makes all unchecked for associated objectives and goals
          projectTarget.projectAccomplishmentTargetObjectives.forEach((projectAccomplishmentTargetObjective) => {
            const oIdStr = projectAccomplishmentTargetObjective.id.toString();
            const tIdStr = projectTarget.id.toString();
            const mark = '|';
            const otId = oIdStr.concat(mark, tIdStr);
            objectivesTobeUnselected.push(otId);
          });
        }
      });
      if (objectivesTobeUnselected.length !== 0) {
        this.updateSelectedTargetObjectives(null, objectivesTobeUnselected);
      }
      this.selectedProjectTargets = this.adjustedProjectTargets.filter((projectTarget) => newValues.includes(projectTarget.id));
      const selectedProjectObjectives = [];

      // ===================================================================
      // 1. Find all projectObjectives which has selectedProjectTargets in their projectObjectiveAccomplishmentTargets
      // 2. Remove projectObjective which isn't selected and is archived.
      // 3. Push into selectedProjectObjectives if it doesn't exist in selectedProjectObjectives.
      // ===================================================================
      this.selectedProjectTargets.forEach((selectedProjectTarget) => {
        // #1.
        const visibleProjectObjectiveIds = [];
        this.projectObjectives.forEach((projectObjective) => {
          projectObjective.projectObjectiveAccomplishmentTargets.forEach((projectObjectiveAccomplishmentTarget) => {
            const projectObjectiveAccomplishmentTargetObject = projectObjectiveAccomplishmentTarget.projectAccomplishmentTarget;
            if (projectObjectiveAccomplishmentTargetObject.id === selectedProjectTarget.id && !visibleProjectObjectiveIds.includes(projectObjective.id)) {
              visibleProjectObjectiveIds.push(projectObjective.id);
              // #2.
              const isInSelection = visibleProjectObjectiveIds.includes(projectObjective.id);
              if (isInSelection) {
              // #3.
                if (!selectedProjectObjectives.includes(projectObjective)) {
                  selectedProjectObjectives.push(projectObjective);
                  if (!this.projectObjectivesSelected.includes(projectObjective.id)) {
                    this.projectObjectivesSelected.push(projectObjective.id);
                  }
                }
              }
            }
          });
        });
      });
    },
    projectObjectivesSelected(newValues) {
      this.cascadeProjectObjectivesSelectedNewValues(newValues);
      const availableProjectGoalIds = [];
      this.projectObjectives.forEach((ProjectObjective) => {
        if (newValues.includes(ProjectObjective.id) && ProjectObjective.projectObjectiveGoals !== undefined) {
          ProjectObjective.projectObjectiveGoals.forEach((projectObjectiveGoal) => {
            if (!this.availableProjectGoals.includes(projectObjectiveGoal)) {
              this.availableProjectGoals.push(projectObjectiveGoal);
              availableProjectGoalIds.push(projectObjectiveGoal.id);
              if (!this.projectGoalsSelected.includes(projectObjectiveGoal.id)) {
                this.projectGoalsSelected.push(projectObjectiveGoal.id);
              }
            }
          });
        }
      });

      this.availableProjectGoals.sort(
        (a, b) => a.name.localeCompare(b.name),
      );
      const selectedProjectObjectives = this.getAllSeletedObjectives();
      const selectedProjectGoals = [];

      // ===================================================================
      // 1. Find all projectGoals which has selectedProjectObjectives in their projectGoalObjectives
      // 2. Remove projectGoal which isn't selected and is archived.
      // 3. Push into selectedProjectGoals if it doesn't exist in selectedProjectGoals.
      // ===================================================================
      selectedProjectObjectives.forEach((selectedProjectObjective) => {
        // #1.
        this.projectGoals.forEach((projectGoal) => {
          projectGoal.projectGoalObjectives.forEach((projectGoalObjective) => {
            const projectGoalObjectiveObject = projectGoalObjective.projectObjective;
            if (projectGoalObjectiveObject.id === selectedProjectObjective.id) {
              // #2.
              const isArchived = (new Date(projectGoal.archiveDate) < Date.now()
                && projectGoal.archiveDate !== '0001-01-01T00:00:00'
                && projectGoal.archiveDate !== '0001-01-01T00:00:00Z');
              const isInSelection = this.projectGoalsSelected.some((gId) => gId === projectGoal.id);
              if (!(isArchived && !isInSelection)) { // any objId of adjustedProjectTargetsSeleted.projectAccomplishmentTargetObjectiveSelected  ==  || this.getAllSeletedObjectiveIds().includes(projectGoal.id)
              // #3.
                if (!selectedProjectGoals.includes(projectGoal)) {
                  selectedProjectGoals.push(projectGoal);
                }
              }
            }
          });
        });
      });
      const selectedProjectGoalIds = selectedProjectGoals.map(
        (selectedProjectGoal) => selectedProjectGoal.id,
      );
      this.projectGoals.forEach((projectGoal) => {
        if (selectedProjectGoalIds.includes(projectGoal.id)) {
          projectGoal.class = '';
        } else {
          projectGoal.class = 'checkbox-hidden';
          const index = this.projectGoalsSelected.indexOf(projectGoal.id);
          if (index > -1) {
            this.projectGoalsSelected.splice(index, 1);
          }
        }
      });
    },
    projectGoalsSelected(newValues) {
      if (this.projectPrimaryGoalsSelected !== null) {
        if (!newValues.includes(this.projectPrimaryGoalsSelected)) {
          this.projectPrimaryGoalsSelected = null;
        }
      }
    },
    projectPrimaryGoalsSelected() {
      try {
        const radioButtons = document.querySelectorAll('input[type="radio"]');
        if (this.projectPrimaryGoalsSelected === null || this.projectPrimaryGoalsSelected === -1) {
          radioButtons.forEach((radioButton) => {
            radioButton.classList.remove('custom-control-input');
            radioButton.classList.add('radio-none-selected');
          });
        } else {
          radioButtons.forEach((radioButton) => {
            radioButton.classList.remove('radio-none-selected');
            radioButton.classList.add('custom-control-input');
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    // Watchers for temporary modal variables
    tempProjectAccomplishmentTargetIdsSelected(newValues) {
      // Update childClass and temp objective selections using the data model (not the DOM)
      this.adjustedProjectTargets.forEach((projectTarget) => {
        if (newValues.includes(projectTarget.id)) {
          projectTarget.childClass = '';
          // Initialize temp objectives if not yet set
          if (!projectTarget.tempProjectAccomplishmentTargetObjectiveSelected) {
            projectTarget.tempProjectAccomplishmentTargetObjectiveSelected = [];
          }
          // Auto-select all objectives for this target that aren't already selected
          projectTarget.projectAccomplishmentTargetObjectives.forEach((objective) => {
            const key = `${objective.id}|${projectTarget.id}`;
            if (!projectTarget.tempProjectAccomplishmentTargetObjectiveSelected.includes(key)) {
              projectTarget.tempProjectAccomplishmentTargetObjectiveSelected.push(key);
            }
          });
        } else {
          // Hide objectives and clear temp selections
          projectTarget.childClass = 'checkbox-hidden';
          projectTarget.tempProjectAccomplishmentTargetObjectiveSelected = [];
        }
      });

      // Collect all objective IDs from selected targets using the data model
      const tempObjectiveIds = [];
      this.adjustedProjectTargets.forEach((projectTarget) => {
        if (newValues.includes(projectTarget.id)) {
          projectTarget.projectAccomplishmentTargetObjectives.forEach((objective) => {
            if (!tempObjectiveIds.includes(objective.id)) {
              tempObjectiveIds.push(objective.id);
            }
          });
        }
      });

      // Rebuild the full set of available goals from the selected objectives
      const availableGoalIds = new Set();
      const availableGoalsMap = new Map();

      this.projectObjectives.forEach((projectObjective) => {
        if (tempObjectiveIds.includes(projectObjective.id) && projectObjective.projectObjectiveGoals) {
          projectObjective.projectObjectiveGoals.forEach((goal) => {
            availableGoalIds.add(goal.id);
            if (!availableGoalsMap.has(goal.id)) {
              availableGoalsMap.set(goal.id, goal);
            }
          });
        }
      });

      // Always rebuild modalAvailableProjectGoals to reflect the current target selection (modal only)
      const newAvailableGoals = Array.from(availableGoalsMap.values());
      newAvailableGoals.sort((a, b) => a.name.localeCompare(b.name));
      this.modalAvailableProjectGoals = newAvailableGoals;

      // Update temp goals selected to include all available goals
      this.tempProjectGoalsSelected = Array.from(availableGoalIds);

      // Update goal visibility on the modal list only
      this.modalAvailableProjectGoals.forEach((goal) => {
        goal.class = availableGoalIds.has(goal.id) ? '' : 'checkbox-hidden';
      });
    },
    tempProjectGoalsSelected(newValues) {
      // Clear primary goal if it's no longer selected
      if (this.tempProjectPrimaryGoalsSelected !== null) {
        if (!newValues.includes(this.tempProjectPrimaryGoalsSelected)) {
          this.tempProjectPrimaryGoalsSelected = null;
        }
      }
    },

  },
  mounted() {
    this.projectId = parseInt(this.$route.params.id, 10);
    (async () => {
      await this.load();
    })();
  },
  methods: {
    getGoalsForTarget(target) {
      // Get all unique goals from the target's objectives
      const goalsSet = new Set();
      target.projectAccomplishmentTargetObjectives.forEach((objective) => {
        if (objective.projectObjectiveGoals) {
          objective.projectObjectiveGoals.forEach((goal) => {
            goalsSet.add(goal.id);
          });
        }
      });
      // Return filtered goals that belong to this target
      return this.availableProjectGoals.filter((goal) => goalsSet.has(goal.id));
    },
    isTargetUnavailable(target) {
      // A target is unavailable (gray/disabled) if it has no objectives, or if none
      // of its objectives have any associated goals. Because the modal hides the
      // objectives column, the user needs targets with no reachable goals to also
      // appear disabled.
      const objectives = target.projectAccomplishmentTargetObjectives || [];
      if (objectives.length === 0) return true;
      return !objectives.some(
        (objective) => Array.isArray(objective.projectObjectiveGoals)
          && objective.projectObjectiveGoals.length > 0,
      );
    },
    targetUnavailableTitle(target) {
      const objectives = target.projectAccomplishmentTargetObjectives || [];
      if (objectives.length === 0) return 'No associated Objectives available.';
      const hasAnyGoals = objectives.some(
        (objective) => Array.isArray(objective.projectObjectiveGoals)
          && objective.projectObjectiveGoals.length > 0,
      );
      if (!hasAnyGoals) return 'No associated Goals available.';
      return '';
    },
    onGoalFilterSelect(value) {
      if (value != null && !this.selectedGoalFilters.includes(value)) {
        this.selectedGoalFilters.push(value);
      }
      this.goalDropdownValue = null;
    },
    removeGoalFilter(id) {
      this.selectedGoalFilters = this.selectedGoalFilters.filter((goalId) => goalId !== id);
    },
    onOpenProjectTOGModalClick() {
      const savedPrimary = this.projectPrimaryGoalsSelected;
      // Start each visit to the modal with the full target list
      this.selectedGoalFilters = [];
      this.goalDropdownValue = null;
      // Stash the saved primary so onProjectTOGModalShown can re-apply it after the
      // modal's radios mount (initial v-model sometimes doesn't reflect to per-row
      // b-form-radio-group instances rendered from a freshly-rebuilt list).
      this.pendingPrimaryToRestore = savedPrimary;

      // Copy target-objective selections to temporary state first (before triggering watcher)
      this.adjustedProjectTargets.forEach((target) => {
        target.tempProjectAccomplishmentTargetObjectiveSelected = [...(target.projectAccomplishmentTargetObjectiveSelected || [])];
      });

      // Seed modalAvailableProjectGoals from current availableProjectGoals so the watcher
      // starts with a full list before rebuilding it for the selected targets.
      this.modalAvailableProjectGoals = this.availableProjectGoals.map((g) => ({ ...g }));

      // Seed the saved primary BEFORE the target-ids assignment so the watcher chain
      // (which reassigns tempProjectGoalsSelected) sees the existing primary and the
      // tempProjectGoalsSelected watcher does NOT null it out (the new goals list still
      // contains the saved primary).
      this.tempProjectPrimaryGoalsSelected = savedPrimary;

      // Assigning tempProjectAccomplishmentTargetIdsSelected triggers the watcher which
      // rebuilds modalAvailableProjectGoals and resets tempProjectGoalsSelected.
      this.tempProjectAccomplishmentTargetIdsSelected = [...this.projectAccomplishmentTargetIdsSelected];

      // Show the modal; onProjectTOGModalShown will re-apply pendingPrimaryToRestore
      // once the modal contents (radios) have finished mounting.
      this.$nextTick(() => {
        this.$bvModal.show(this.projectTOGModalId);
      });
    },
    onProjectTOGModalShown() {
      // Re-apply the saved primary after the modal's radios are fully mounted so the
      // correct radio shows as checked when the modal opens. Do NOT toggle through null
      // first - both modal and report radios share name="primaryRadio" so a null pass
      // would visually uncheck the report's radio as well.
      const target = this.pendingPrimaryToRestore;
      this.pendingPrimaryToRestore = null;
      if (target == null) return;

      this.$nextTick(() => {
        if (this.tempProjectGoalsSelected.includes(target)
            && this.tempProjectPrimaryGoalsSelected !== target) {
          this.tempProjectPrimaryGoalsSelected = target;
        }
      });
    },
    onCancelClick() {
      // Close the modal without saving changes
      this.resetTempVariables();
      this.$bvModal.hide(this.projectTOGModalId);
    },
    resetTempVariables() {
      this.tempProjectAccomplishmentTargetIdsSelected = [];
      this.tempProjectGoalsSelected = [];
      this.tempProjectPrimaryGoalsSelected = null;
      this.modalAvailableProjectGoals = [];
      this.pendingPrimaryToRestore = null;
      this.adjustedProjectTargets.forEach((target) => {
        target.tempProjectAccomplishmentTargetObjectiveSelected = [];
      });
    },
    sortArrayByPair(arr) {
      arr.sort((a, b) => {
        const [aFirst, aSecond] = a.split('|');
        const [bFirst, bSecond] = b.split('|');
        if (parseInt(aSecond, 0) < parseInt(bSecond, 0)) return -1;
        if (parseInt(aSecond, 0) > parseInt(bSecond, 0)) return 1;
        if (parseInt(aFirst, 0) < parseInt(bFirst, 0)) return -1;
        if (parseInt(aFirst, 0) > parseInt(bFirst, 0)) return 1;
        return 0;
      });
      return arr;
    },
    toggleTargetSelection(targetId, isDisabled) {
      if (isDisabled) return;

      const index = this.tempProjectAccomplishmentTargetIdsSelected.indexOf(targetId);
      if (index > -1) {
        // Remove from selection - create new array to ensure reactivity
        this.tempProjectAccomplishmentTargetIdsSelected = this.tempProjectAccomplishmentTargetIdsSelected.filter((id) => id !== targetId);
      } else {
        // Add to selection - create new array to ensure reactivity
        this.tempProjectAccomplishmentTargetIdsSelected = [...this.tempProjectAccomplishmentTargetIdsSelected, targetId];
      }
    },
    handleTargetCheckboxChange() {
      // This handler ensures the checkbox change event is captured
      // The v-model will handle the actual state update
    },
    arraysAreEqual(array1, array2) {
      if (!Array.isArray(array1) || !Array.isArray(array2)) {
        return false;
      }

      if (array1.length !== array2.length) {
        return false;
      }

      for (let i = 0; i < array1.length; i += 1) {
        if (array1[i] !== array2[i]) {
          return false;
        }
      }
      return true;
    },
    checkExportable() {
      const selectedTargetCheckboxes = this.getCheckedTargets();
      const selectedObjectiveCheckboxes = this.getCheckedObjectives();
      const selectedGoalCheckboxes = this.getCheckedGoals();
      const selectedPrimaryGoalRadio = this.getPrimaryGoalId();
      if (selectedTargetCheckboxes.length === 0 && selectedObjectiveCheckboxes.length === 0 && selectedGoalCheckboxes.length === 0 && selectedPrimaryGoalRadio === null) { // init load
        this.isExportable = true;
      } else {
        const isTargetUnchanged = this.arraysAreEqual(this.savedTargetSelections, selectedTargetCheckboxes);
        const isObjectiveUnchanged = this.arraysAreEqual(this.savedObjectivesSelections, selectedObjectiveCheckboxes);
        const isGoalUnchanged = this.arraysAreEqual(this.savedGoalSelections, selectedGoalCheckboxes);
        const isPrimaryGoalUnchanged = this.savedPrimaryGoalId === selectedPrimaryGoalRadio;
        if (isTargetUnchanged && isObjectiveUnchanged && isGoalUnchanged && isPrimaryGoalUnchanged) {
          this.isExportable = true;
        } else {
          this.isExportable = false;
        }
        if (selectedTargetCheckboxes.length > 0) {
          this.isExportable = true;
        } else {
          this.isExportable = false;
        }
      }
    },
    getCheckedTargets() {
      const targetCheckboxes = document.getElementsByName('adjustedProjectTargets');
      const checkedTargetIds = [];
      targetCheckboxes.forEach((t) => {
        if (t.checked) {
          checkedTargetIds.push(parseInt(t.defaultValue, 0));
        }
      });
      return checkedTargetIds.sort((a, b) => a - b);
    },
    getCheckedObjectives() {
      const objectiveCheckboxes = document.getElementsByName('projectObjectives');
      const checkedObjectives = [];
      objectiveCheckboxes.forEach((obj) => {
        if (obj.checked) {
          checkedObjectives.push(obj.defaultValue);
        }
      });
      const sortedCheckedObjectives = this.sortArrayByPair(checkedObjectives);
      return sortedCheckedObjectives;
    },
    getCheckedGoals() {
      const goalCheckboxes = document.getElementsByName('goals');
      const checkedGoalIds = [];
      goalCheckboxes.forEach((g) => {
        if (g.checked) {
          checkedGoalIds.push(parseInt(g.defaultValue, 0));
        }
      });
      return checkedGoalIds.sort((a, b) => a - b);
    },
    uncheckTarget(targetId) {
      const index = this.projectAccomplishmentTargetIdsSelected.indexOf(targetId);
      if (index > -1) {
        this.projectAccomplishmentTargetIdsSelected.splice(index, 1);
      }
    },
    getPrimaryGoalId() {
      let primaryGoalRadio = [];
      primaryGoalRadio = document.getElementsByName('primaryRadio');
      const primaryGoalId = [];
      primaryGoalRadio.forEach((pg) => {
        if (pg.checked) {
          primaryGoalId.push(parseInt(pg.defaultValue, 0));
        }
      });
      if (primaryGoalId.length === 0) {
        return null;
      }
      return primaryGoalId[0];
    },
    toggleChild(id) {
      const plusId = id.replace('Child', 'Plus');
      const x = document.getElementById(id);
      const plus = document.getElementById(plusId);
      if (x.style.display === 'none') {
        x.style.display = 'block';
        plus.textContent = '−';
      } else {
        x.style.display = 'none';
        plus.textContent = '+';
      }
    },
    getAllSeletedObjectives() {
      const adjustedProjectTargetsSeleted = this.adjustedProjectTargets.filter((adjustedProjectTarget) => this.projectAccomplishmentTargetIdsSelected.includes(adjustedProjectTarget.id));

      const SeletedObjectives = [];
      adjustedProjectTargetsSeleted.forEach((projectTarget) => {
        projectTarget.projectAccomplishmentTargetObjectiveSelected.forEach((selection) => {
          const objId = parseInt(selection.split('|')[0], 10);
          projectTarget.projectAccomplishmentTargetObjectives.forEach((projectAccomplishmentTargetObjective) => {
            if (projectAccomplishmentTargetObjective.id === objId) {
              SeletedObjectives.push(projectAccomplishmentTargetObjective);
            }
          });

        });
      });
      return SeletedObjectives;
    },
    getAllSeletedObjectiveIds() {
      const adjustedProjectTargetsSeleted = this.adjustedProjectTargets.filter((adjustedProjectTarget) => this.projectAccomplishmentTargetIdsSelected.includes(adjustedProjectTarget.id));

      const SeletedObjectiveIds = [];
      adjustedProjectTargetsSeleted.forEach((projectTarget) => {
        projectTarget.projectAccomplishmentTargetObjectiveSelected.forEach((selection) => {
          const objId = parseInt(selection.split('|')[0], 10);
          SeletedObjectiveIds.push(objId);
        });
      });
      return SeletedObjectiveIds;
    },
    getTempSelectedObjectiveIds() {
      const adjustedProjectTargetsSeleted = this.adjustedProjectTargets.filter((adjustedProjectTarget) => this.tempProjectAccomplishmentTargetIdsSelected.includes(adjustedProjectTarget.id));

      const selectedObjectiveIds = [];
      adjustedProjectTargetsSeleted.forEach((projectTarget) => {
        if (projectTarget.tempProjectAccomplishmentTargetObjectiveSelected) {
          projectTarget.tempProjectAccomplishmentTargetObjectiveSelected.forEach((selection) => {
            const objId = parseInt(selection.split('|')[0], 10);
            selectedObjectiveIds.push(objId);
          });
        }
      });
      return selectedObjectiveIds;
    },
    updateSelectedTargetObjectives(event, values) {
      let objectiveIdInt = 0;
      let targetIdInt = 0;
      const currentProjectObjectivesSelected = this.getAllSeletedObjectiveIds().slice();
      if (values.length > 0) {
        const targetId = values[0].substring(values[0].indexOf('|') + 1, values[0].length);
        targetIdInt = parseInt(targetId, 0);
        values.forEach((value) => {
          const objectiveId = value.substring(0, value.indexOf('|'));
          objectiveIdInt = parseInt(objectiveId, 0);
          if (event === null) {
            if (currentProjectObjectivesSelected.includes(objectiveIdInt)) {
              const index = currentProjectObjectivesSelected.indexOf(objectiveIdInt);
              currentProjectObjectivesSelected.splice(index, 1);
            }
          } else if (event !== null) { // if objective checkboxes are enabled
            const projectTargetToAdd = this.adjustedProjectTargets.filter((adjustedProjectTarget) => adjustedProjectTarget.id === targetIdInt);
            projectTargetToAdd[0].projectAccomplishmentTargetObjectiveSelected.push(value);
            if (!currentProjectObjectivesSelected.includes(objectiveIdInt)) {
              currentProjectObjectivesSelected.push(objectiveIdInt);
            }
          }
        });
      }
      this.projectObjectivesSelected = currentProjectObjectivesSelected;
    },
    cascadeProjectObjectivesSelectedNewValues(newValues) {
      const selectedProjectObjectives = this.adjustedProjectObjectives.filter((Objective) => newValues.includes(Objective.id));
      const selectedProjectObjectiveGoalIds = this.getDistinctProjectObjectiveGoalIds(selectedProjectObjectives, 'selected');

      if (newValues.length === 0) {
        this.projectGoalsSelected = [];
      } else {
        this.projectGoalsSelected = selectedProjectObjectiveGoalIds;

      }
      const unselectedProjectObjectives = this.adjustedProjectObjectives.filter((Objective) => !newValues.includes(Objective.id));
      const unselectedProjectObjectiveGoalIds = this.getDistinctProjectObjectiveGoalIds(unselectedProjectObjectives, 'unselected');
      const removableprojectObjectiveGoalIds = [];

      unselectedProjectObjectiveGoalIds.forEach((projectGoalId) => {
        if (!selectedProjectObjectiveGoalIds.includes(projectGoalId)) {
          removableprojectObjectiveGoalIds.push(projectGoalId);
        }
      });

      removableprojectObjectiveGoalIds.forEach((projectGoalId) => {
        if (this.projectGoalsSelected.includes(projectGoalId)) {
          const index = this.projectGoalsSelected.indexOf(projectGoalId);
          this.projectGoalsSelected.splice(index, 1);
        }
      });
      this.checkExportable();
    },
    getDistinctProjectObjectiveGoalIds(projectObjectives, choice) {
      const ids = [];
      if (choice === 'selected') {
        projectObjectives.forEach((projectObjective) => {
          this.projectGoals.forEach((projectGoal) => {

            // filter for valid Objectives and selected Objectives
            if (((new Date(projectGoal.archiveDate) > Date.now()
            || projectGoal.archiveDate === '0001-01-01T00:00:00'
            || projectGoal.archiveDate === '0001-01-01T00:00:00Z'))
            && (projectGoal.projectGoalObjectives.some((projectGoalObjective) => projectGoalObjective.projectObjectiveId === projectObjective.id))) {
              if (!ids.includes(projectGoal.id)) {
                ids.push(projectGoal.id);
              }
            }
          });
        });
      }
      return ids.sort();
    },
    getadjustedProjectTargetsSeleted() {
      const adjustedProjectTargetsSeleted = this.adjustedProjectTargets.filter((adjustedProjectTarget) => this.projectAccomplishmentTargetIdsSelected.includes(adjustedProjectTarget.id));
      return adjustedProjectTargetsSeleted;
    },
    multiSort(arr, primaryKey, secondaryKey) {
      arr.sort((a, b) => {
        if (a[primaryKey] < b[primaryKey]) return -1;
        if (a[primaryKey] > b[primaryKey]) return 1;
        if (a[secondaryKey] < b[secondaryKey]) return -1;
        if (a[secondaryKey] > b[secondaryKey]) return 1;
        return 0;
      });
      return arr;
    },
    createTargetSelections() {
      const adjustedProjectTargetsSeleted = this.getadjustedProjectTargetsSeleted();
      const selections = [];
      adjustedProjectTargetsSeleted.forEach((projectTarget) => {
        projectTarget.projectAccomplishmentTargetObjectiveSelected.forEach((selection) => {
          const objId = parseInt(selection.split('|')[0], 10);
          const targetId = parseInt(selection.split('|')[1], 10);
          selections.push({
            projectId: this.projectId,
            projectObjectiveId: objId,
            projectAccomplishmentTargetId: targetId,
          });
        });
      });
      return this.multiSort(selections, 'projectAccomplishmentTargetId', 'projectObjectiveId');
    },
    createObjectivesSelections() {
      const adjustedProjectTargetsSeleted = this.getadjustedProjectTargetsSeleted();
      const objectivesSelections = [];
      adjustedProjectTargetsSeleted.forEach((projectTarget) => {
        projectTarget.projectAccomplishmentTargetObjectiveSelected.forEach((selection) => {
          const objId = parseInt(selection.split('|')[0], 10);
          if (!objectivesSelections.includes(objId)) {
            objectivesSelections.push(objId);
          }
        });
      });
      const sortedObjectivesSelections = objectivesSelections.sort((a, b) => a - b);
      return sortedObjectivesSelections;
    },
    async load() {

      await this.$store.dispatch('Project/getProject', this.projectId);
      await this.$store.dispatch('Project/getProjectAccomplishmentTargetsAsync');
      await this.$store.dispatch('Project/getProjectGoalsAsync');
      await this.$store.dispatch('Project/getProjectGoalSelectionsAsync', this.projectId);
      await this.$store.dispatch('Project/getProjectObjectiveAccomplishmentTargetSelectionsAsync', this.projectId);
      await this.$store.dispatch('Project/getProjectObjectivesAsync');
      await this.$store.dispatch('Project/getProjectObjectiveSelectionsAsync', this.projectId);

      this.projectGoalSelections.forEach(
        (projectGoalSelection) => {
          if (!this.projectGoalsSelected.includes(projectGoalSelection.projectGoalId)) {
            this.projectGoalsSelected.push(projectGoalSelection.projectGoalId);
          }
          if (projectGoalSelection.isPrimary === true) {
            this.projectPrimaryGoalsSelected = projectGoalSelection.projectGoalId;
          }
        },
      );
      this.projectObjectiveSelections.forEach(
        (projectObjectiveSelection) => this.projectObjectivesSelected.push(projectObjectiveSelection.projectObjectiveId),
      );
      this.projectObjectiveAccomplishmentTargetSelections.forEach(
        (projectObjectiveAccomplishmentTargetSelection) => {
          if (!this.projectAccomplishmentTargetIdsSelected.includes(projectObjectiveAccomplishmentTargetSelection.projectAccomplishmentTargetId)) {
            this.projectAccomplishmentTargetIdsSelected.push(projectObjectiveAccomplishmentTargetSelection.projectAccomplishmentTargetId);
          }
        },
      );

      // filter for valid Goals and selected Goals
      this.adjustedProjectGoals = this.projectGoals.filter((projectGoal) => (
        (new Date(projectGoal.archiveDate) > Date.now()
        || projectGoal.archiveDate === '0001-01-01T00:00:00'
        || projectGoal.archiveDate === '0001-01-01T00:00:00Z')
        || (this.projectGoalSelections.some((projectGoalSelection) => projectGoalSelection.projectGoalId === projectGoal.id))));

      this.projectObjectives.forEach((projectObjective) => {

        projectObjective.class = 'checkbox-hidden';
        projectObjective.projectObjectiveAccomplishmentTargetsSelected = this.projectObjectiveAccomplishmentTargetSelections.filter(
          (e) => e.projectObjectiveId === projectObjective.id,
        ).map(
          (e) => `${e.projectObjectiveId}|${e.projectAccomplishmentTargetId}`,
        );
        projectObjective.projectObjectiveAccomplishmentTargets.forEach((projectObjectiveAccomplishmentTarget) => {
          projectObjectiveAccomplishmentTarget.class = 'checkbox-hidden';
          projectObjectiveAccomplishmentTarget.childClass = 'checkbox-hidden';
        });
        // filter for valid Targets and selected Targets
        projectObjective.projectObjectiveAccomplishmentTargets = projectObjective.projectObjectiveAccomplishmentTargets.filter((item) => (
          new Date(item.projectAccomplishmentTarget.archiveDate) > Date.now()
          || item.projectAccomplishmentTarget.archiveDate === '0001-01-01T00:00:00'
          || item.projectAccomplishmentTarget.archiveDate === '0001-01-01T00:00:00Z'
          || (this.projectObjectiveAccomplishmentTargetSelections.some((projectObjectiveAccomplishmentTargetSelection) => projectObjectiveAccomplishmentTargetSelection.projectAccomplishmentTargetId === item.projectAccomplishmentTargetId))));

      });

      // filter for valid Goals and selected Goals
      this.adjustedProjectTargets = this.projectAccomplishmentTargets.filter((projectTarget) => (
        (new Date(projectTarget.archiveDate) > Date.now()
        || projectTarget.archiveDate === '0001-01-01T00:00:00'
        || projectTarget.archiveDate === '0001-01-01T00:00:00Z')
        || (this.projectObjectiveAccomplishmentTargetSelections.some((projectTargetSelection) => projectTargetSelection.projectAccomplishmentTargetId === projectTarget.id))));
      this.adjustedProjectTargets.sort(
        (a, b) => a.name.localeCompare(b.name),
      );
      this.adjustedProjectObjectives = this.projectObjectives.filter((projectObjective) => (
        (new Date(projectObjective.archiveDate) > Date.now()
        || projectObjective.archiveDate === '0001-01-01T00:00:00'
        || projectObjective.archiveDate === '0001-01-01T00:00:00Z')
        || (this.projectObjectiveSelections.some((projectObjectiveSelection) => projectObjectiveSelection.projectObjectiveId === projectObjective.id))));

      this.adjustedProjectTargets.forEach((adjustedProjectTarget) => {
        adjustedProjectTarget.childClass = 'checkbox-hidden'; // for init
        adjustedProjectTarget.projectAccomplishmentTargetObjectives = [];
        adjustedProjectTarget.projectAccomplishmentTargetObjectiveSelected = [];
        this.adjustedProjectObjectives.forEach((adjustedProjectObjective) => {
          const isForTarget = adjustedProjectObjective.projectObjectiveAccomplishmentTargets.some((projectObjectiveAccomplishmentTarget) => (
            projectObjectiveAccomplishmentTarget.projectAccomplishmentTargetId === adjustedProjectTarget.id
          ));
          if (isForTarget) {
            adjustedProjectObjective.associatedTargetId = adjustedProjectTarget.id;
            adjustedProjectTarget.projectAccomplishmentTargetObjectives.push(adjustedProjectObjective);

            this.projectObjectiveAccomplishmentTargetSelections.forEach((projectObjectiveAccomplishmentTargetSelection) => {
              if (projectObjectiveAccomplishmentTargetSelection.projectAccomplishmentTargetId === adjustedProjectTarget.id && projectObjectiveAccomplishmentTargetSelection.projectObjectiveId === adjustedProjectObjective.id) {
                adjustedProjectTarget.projectAccomplishmentTargetObjectiveSelected.push(`${adjustedProjectObjective.id}|${adjustedProjectTarget.id}`);
              }
            });
          }
        });
      });
      const availableProjectGoalIds = [];
      this.adjustedProjectObjectives.forEach((adjustedProjectObjective) => {
        adjustedProjectObjective.projectObjectiveGoals = [];
        this.adjustedProjectGoals.forEach((adjustedProjectGoal) => {
          const isForObjective = adjustedProjectGoal.projectGoalObjectives.some((projectGoalObjective) => (
            projectGoalObjective.projectObjectiveId === adjustedProjectObjective.id
          ));
          if (isForObjective) {
            adjustedProjectObjective.projectObjectiveGoals.push(adjustedProjectGoal);
          }
        });
        if (this.projectObjectivesSelected.includes(adjustedProjectObjective.id)) {
          adjustedProjectObjective.projectObjectiveGoals.forEach((projectObjectiveGoal) => {
            if (!availableProjectGoalIds.includes(projectObjectiveGoal.id)) {
              availableProjectGoalIds.push(projectObjectiveGoal.id);
            }
          });
        }
      });
      // Set loaded selections
      const savedTargetObjectiveSelections = this.createTargetSelections();
      const loadedTargetSelections = [];
      const loadedObjectivesSelections = [];
      savedTargetObjectiveSelections.forEach((savedTargetObjectiveSelection) => {
        if (!loadedTargetSelections.includes(savedTargetObjectiveSelection.projectAccomplishmentTargetId)) {
          loadedTargetSelections.push(savedTargetObjectiveSelection.projectAccomplishmentTargetId);
        }
        loadedObjectivesSelections.push(`${savedTargetObjectiveSelection.projectObjectiveId}|${savedTargetObjectiveSelection.projectAccomplishmentTargetId}`);
      });
      this.savedTargetSelections = loadedTargetSelections;
      this.savedObjectivesSelections = loadedObjectivesSelections;
      this.savedGoalSelections = this.projectGoalsSelected.sort((a, b) => a - b);
      this.savedPrimaryGoalId = this.projectPrimaryGoalsSelected;

      // Populate selectedProjectTargets on initial load for isReportSavable
      this.selectedProjectTargets = this.adjustedProjectTargets.filter((projectTarget) => this.projectAccomplishmentTargetIdsSelected.includes(projectTarget.id));
    },
    onSaveClick() {
      const isModalOpen = document.getElementById(this.projectTOGModalId) !== null
        && document.getElementById(this.projectTOGModalId).style.display !== 'none';
      const savingFromModal = this.tempProjectAccomplishmentTargetIdsSelected.length > 0
        || this.tempProjectGoalsSelected.length > 0
        || this.tempProjectPrimaryGoalsSelected !== null;

      if (isModalOpen || savingFromModal) {
        // Copy temporary modal values to actual data
        this.projectAccomplishmentTargetIdsSelected = [...this.tempProjectAccomplishmentTargetIdsSelected];
        this.projectGoalsSelected = [...this.tempProjectGoalsSelected];
        this.projectPrimaryGoalsSelected = this.tempProjectPrimaryGoalsSelected;

        // Promote the modal's goal list to the report now that the save is confirmed
        this.availableProjectGoals = this.modalAvailableProjectGoals.map((g) => ({ ...g }));

        // Copy target-objective selections from temporary state
        this.adjustedProjectTargets.forEach((target) => {
          target.projectAccomplishmentTargetObjectiveSelected = [...(target.tempProjectAccomplishmentTargetObjectiveSelected || [])];
        });

        // Update projectObjectivesSelected from the target-objective selections
        const objectiveIds = [];
        this.adjustedProjectTargets.forEach((target) => {
          if (this.projectAccomplishmentTargetIdsSelected.includes(target.id)) {
            target.projectAccomplishmentTargetObjectiveSelected.forEach((selection) => {
              const objId = parseInt(selection.split('|')[0], 10);
              if (!objectiveIds.includes(objId)) {
                objectiveIds.push(objId);
              }
            });
          }
        });
        this.projectObjectivesSelected = objectiveIds;

        // Close the modal
        this.$bvModal.hide(this.projectTOGModalId);
      }
      // else: saving directly from report - use existing actual data as-is

      this.modelSaved();

      if (!this.validateProjectGoals()) {
        this.showProjectGoalValidationErrorAlert();
        return;
      }

      if (!this.validateProjectObjectives()) {
        this.showProjectObjectiveValidationErrorAlert();
        return;
      }

      (async () => {

        this.projectGoalsSaving = true;

        await this.$store.dispatch(
          'Project/setProjectGoalSelectionsAsync',
          {
            projectId: this.projectId,
            selections: this.projectGoalsSelected.map(
              (item) => ({ projectId: this.projectId, projectGoalId: item, isPrimary: this.projectPrimaryGoalsSelected === item }),
            ),
          },
        );
        this.savedGoalSelections = this.projectGoalsSelected.sort((a, b) => a - b);
        this.savedPrimaryGoalId = this.projectPrimaryGoalsSelected;
        const selections = this.createTargetSelections();
        const objectivesSelections = this.createObjectivesSelections();
        await this.$store.dispatch(
          'Project/setProjectObjectiveSelectionsAsync',
          {
            projectId: this.projectId,
            selections: objectivesSelections.map(
              (item) => ({ projectId: this.projectId, projectObjectiveId: item }),
            ),
          },
        );

        await this.$store.dispatch(
          'Project/setProjectObjectiveAccomplishmentTargetSelectionAsync',
          { projectId: this.projectId, selections },
        );

        this.projectGoalsSaving = false;

        this.showProjectGoalSaveSuccessAlert();

        this.savedTargetSelections = this.getCheckedTargets();
        this.savedObjectivesSelections = this.getCheckedObjectives();
        this.savedGoalSelections = this.getCheckedGoals();
        this.savedPrimaryGoalId = this.getPrimaryGoalId();

        // Reset temp variables so subsequent report Save clicks don't re-apply stale temp data
        this.resetTempVariables();

      })();

    },
    showProjectGoalValidationErrorAlert() {
      this.dismissProjectGoalValidationErrorAlert = 5;
    },
    dismissProjectGoalValidationErrorAlertChanged(value) {
      this.dismissProjectGoalValidationErrorAlert = value;
    },
    showProjectObjectiveValidationErrorAlert() {
      this.dismissProjectObjectiveValidationErrorAlert = 5;
    },
    dismissProjectObjectiveValidationErrorAlertChanged(value) {
      this.dismissProjectObjectiveValidationErrorAlert = value;
    },
    showProjectGoalSaveSuccessAlert() {
      this.dismissProjectGoalSaveSuccessAlert = 5;
    },
    dismissProjectGoalSaveSuccessAlertChanged(value) {
      this.dismissProjectGoalSaveSuccessAlert = value;
    },
    validateProjectGoals() {

      const validationErrors = [];
      const projectGoalsFiltered = this.projectGoals.filter((projectGoal) => this.projectGoalsSelected.includes(projectGoal.id));

      projectGoalsFiltered.forEach((projectGoal) => {
        const projectGoalObjectiveIds = (projectGoal.projectGoalObjectives.map((projectGoalObjective) => projectGoalObjective.projectObjectiveId));
        const intersection = this.projectObjectivesSelected.filter((id) => projectGoalObjectiveIds.includes(id));
        if (intersection.length === 0) {
          validationErrors.push(projectGoal.id);
        }
      });
      return (validationErrors.length === 0);
    },
    validateProjectObjectives() {

      const validationErrors = [];
      const adjustedProjectTargetsFiltered = this.adjustedProjectTargets.filter((adjustedProjectTarget) => this.projectAccomplishmentTargetIdsSelected.includes(adjustedProjectTarget.id));
      adjustedProjectTargetsFiltered.forEach((adjustedProjectTarget) => {
        if (adjustedProjectTarget.projectAccomplishmentTargetObjectiveSelected.length === 0) {
          validationErrors.push(adjustedProjectTarget.id);
        }
      });
      return (validationErrors.length === 0);
    },
  },
};
</script>
